import React, { createContext, useContext } from 'react';
import { usePopup } from '../hooks/use-popup';
import AnimatedPopup from '../components/ui/animated-popup';

const PopupContext = createContext();

export const usePopupContext = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopupContext must be used within a PopupProvider');
  }
  return context;
};

export const PopupProvider = ({ children }) => {
  const popupMethods = usePopup();
  const { popups, hidePopup } = popupMethods;

  return (
    <PopupContext.Provider value={popupMethods}>
      {children}
      
      {/* Render all active popups */}
      {popups.map((popup) => (
        <AnimatedPopup
          key={popup.id}
          isOpen={popup.isOpen}
          onClose={() => hidePopup(popup.id)}
          type={popup.type}
          title={popup.title}
          message={popup.message}
          duration={popup.duration}
          position={popup.position}
        />
      ))}
    </PopupContext.Provider>
  );
};